import React, { Component } from "react";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  getAddressByText,
  getAddressByTel,
  getAddressByPosition
} from "../../services/api.js";
import {
  CONFIRM_ADDRESS_TITLE,
  BUTTON_TEXT_CONFIRM,
  BUTTON_TEXT_CANCEL,
  ERROR_TEXT_NETWORK,
  ERROR_TEXT_NO_RESULT
} from "../../text.js";

const ConfirmAddressContainer = styled.div``;
const LoadingContainer = styled.div`
  justify-content: center;
  display: flex;
`;

const mobileRegExp = new RegExp("(0|\\+33|0033)[1-9][0-9]{8}");

class ConfirmAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentAddressValue: props.value,
      isLoading: true,
      options: [],
      value: null,
      error: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        currentAddressValue: nextProps.value,
        isLoading: true,
        options: [],
        value: null,
        error: null
      });
      if (nextProps.value) {
        if (!nextProps.value.lat) {
          if (
            nextProps.value &&
            mobileRegExp.test(nextProps.value.replace(/ /g, ""))
          ) {
            getAddressByTel(nextProps.value.replace(/ /g, "")).then(resp => {
              this.handleResp(resp);
            });
          } else {
            const address = nextProps.value;
            let oneLineAdress = "";
            if (typeof address === "string") {
              oneLineAdress = address;
            } else {
              oneLineAdress = `${address.rue} ${address.codePostal} ${
                address.ville
              }`;
            }

            getAddressByText(oneLineAdress).then(resp => {
              this.handleResp(resp);
            });
          }
        } else {
          getAddressByPosition(nextProps.value).then(resp => {
            this.handleResp(resp);
          });
        }
      }
    }
  }

  handleResp = resp => {
    if (resp && resp.data && resp.data.length >= 0) {
      this.setState({
        isLoading: false,
        options: resp.data,
        value: "0",
        error: null
      });
    } else {
      this.setState({
        isLoading: false,
        options: [],
        value: null,
        error: true
      });
    }
  };

  handleCancel = () => {
    this.props.onClose(null);
  };

  handleOk = () => {
    this.props.onClose(this.state.options[parseInt(this.state.value)]);
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { isLoading, error } = this.state;
    const { value, ...other } = this.props;
    return (
      <ConfirmAddressContainer>
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          aria-labelledby="confirmation-dialog-title"
          {...other}
        >
          <DialogTitle id="confirmation-dialog-title">
            {CONFIRM_ADDRESS_TITLE}
          </DialogTitle>
          <DialogContent>
            {isLoading || error ? (
              isLoading ? (
                <LoadingContainer>
                  <CircularProgress />
                </LoadingContainer>
              ) : (
                <div>{ERROR_TEXT_NETWORK}</div>
              )
            ) : (
              <div>
                {this.state.options.length === 0 && (
                  <div>{ERROR_TEXT_NO_RESULT}</div>
                )}
                {this.state.options.length > 0 && (
                  <RadioGroup
                    aria-label="address"
                    name="address"
                    value={this.state.value}
                    onChange={this.handleChange}
                  >
                    {this.state.options.map((option, index) => (
                      <FormControlLabel
                        value={index.toString()}
                        key={`${option.rue} ${option.ville}`}
                        control={<Radio />}
                        label={`${option.rue}, ${option.ville}`}
                      />
                    ))}
                  </RadioGroup>
                )}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCancel} color="primary">
              {BUTTON_TEXT_CANCEL}
            </Button>
            {!(Boolean(isLoading) || Boolean(error)) &&
              this.state.options.length !== 0 && (
                <Button onClick={this.handleOk} color="primary">
                  {BUTTON_TEXT_CONFIRM}
                </Button>
              )}
          </DialogActions>
        </Dialog>
      </ConfirmAddressContainer>
    );
  }
}

export default ConfirmAddress;
